// extracted by mini-css-extract-plugin
module.exports = {"registrationNumberField":"ExternalCarForm_registrationNumberField__3Whuh","clearButton":"ExternalCarForm_clearButton__fW1a9"};